import cn from 'classnames';
import React, { ChangeEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@react-md/form';
import { UserObjectModelModel } from '@models';
import { DateTransform } from '@components/date';
import {
    ModelRow,
    ModelLabel,
    ModelThumb,
    ModelActions,
    ModelDownloadAction,
    ModelDeleteAction,
} from '@modules/models';
import { LineItem } from '@components/line-items';
import { Fade } from '@components/animations';
import { ModelSizes } from '@modules/models';
import { getNodeIdComposer } from '@utils';
import { DateTransformType } from '@constants';
import { RootPrefix } from './constants';

import styles from './models-page-model.module.scss';

const _id = getNodeIdComposer(RootPrefix, 'model');

interface UserModelRowProps extends React.HTMLAttributes<HTMLElement> {
    model: UserObjectModelModel;
    onChangeCheckbox: ChangeEventHandler<HTMLInputElement>;
    delay: number;
    in?: boolean;
    checked: boolean;
}

export const ModelsPageModel: React.FC<UserModelRowProps> = ({
    model,
    in: show,
    onChangeCheckbox,
    checked,
    ...rest
}) => {
    const { t } = useTranslation();

    const modelId = model.id;
    const facets = model.getFacets(t);

    return (
        <Fade as="tr" in={show} unmountOnExit {...rest}>
            <td>
                <Checkbox
                    id={_id('checkbox', modelId)}
                    onChange={onChangeCheckbox}
                    checked={checked}
                    value={modelId}
                    disableIconOverlay
                    disableProgrammaticRipple
                    disableRipple
                />
            </td>
            <td>
                <ModelThumb size={'large'} thumb={model.thumb_120x120} />
            </td>

            <td>
                <ModelLabel label={model.title}>
                    <div className={styles.info}>
                        <ModelSizes size={model.size} units={model.units} />

                        <ModelActions>
                            <ModelDownloadAction
                                modelId={modelId}
                                prefix={_id()}
                                originalUrl={model.file_model_original_url}
                                repairedUrl={model.file_model_stl_repaired_url}
                            />
                            {/*<ModelDeleteAction />*/}
                        </ModelActions>
                    </div>
                </ModelLabel>
            </td>

            <td>
                <div className={cn('fieldset-grid', styles.detail)}>
                    <LineItem
                        label={t('labels.status', 'Status')}
                        value={t(`labels.${model.initial_status}`, model.initial_status)}
                    />

                    {facets && <LineItem label={facets.label} value={facets.value} />}
                </div>
            </td>

            <td>
                <LineItem
                    className={styles['last-cells-content']}
                    label={t('labels.uploaded', 'Uploaded')}
                    value={<DateTransform dateString={model.date_created} transformTo={DateTransformType.Locale} />}
                />
            </td>
        </Fade>
    );
};
